import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Plus } from "lucide-react";

/**
 * Shadcn Select with bottom "Add new" CTA.
 * options: [{id, label}]
 */
export default function SelectWithAdd({
  value,
  onChange,
  options,
  placeholder = "Select…",
  onAddNew,
  testId = "select",
  disabled,
}) {
  return (
    <Select
      key={value || "__empty__"}
      value={value || undefined}
      onValueChange={onChange}
      disabled={disabled}
    >
      <SelectTrigger
        data-testid={`${testId}-trigger`}
        className="rounded-none h-10 vsm-surface"
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent
        className="rounded-none vsm-surface border vsm-border"
        data-testid={`${testId}-content`}
      >
        {options.length === 0 && (
          <div className="px-3 py-3 text-sm vsm-muted">No options yet.</div>
        )}
        {options.map((o) => (
          <SelectItem
            key={o.id}
            value={o.id}
            data-testid={`${testId}-option-${o.id}`}
            className="rounded-none"
          >
            {o.label}
          </SelectItem>
        ))}
        {onAddNew && (
          <div className="border-t vsm-border mt-1">
            <button
              type="button"
              data-testid={`${testId}-add-new`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onAddNew();
              }}
              className="w-full px-3 py-2 text-sm flex items-center gap-2 hover:bg-zinc-100 dark:hover:bg-zinc-800 font-medium"
            >
              <Plus className="w-4 h-4" /> Add new
            </button>
          </div>
        )}
      </SelectContent>
    </Select>
  );
}
